import { oneLineTrim } from 'common-tags';
import {
    includeParam,
    pageParam,
    filterParam,
    limitParam as pageSizeParam,
    searchParam,
    sortParam
} from 'app/react/state/middleware/api'

const rootAll = (eventId) => `events/${eventId}/guests`;
const rootOne = (eventId, guestId) => `events/${eventId}/guests/${guestId}`;

export const updateOne = (
    eventId,
    guestId
) => oneLineTrim`
    ${rootOne(eventId, guestId)}
`;

export const deleteOne = (
    eventId,
    guestId
) => oneLineTrim`
    ${rootOne(eventId, guestId)}
`;

export const fetchPaginated = (
    eventId,
    page = 1,
    pageSize = 100,
    filters = {},
    search = '',
    sortKey = '',
    sortOrder = 1,
    includes = []
) => oneLineTrim`
    ${rootAll(eventId)}?
    ${pageParam(page)}&
    ${pageSizeParam(pageSize)}&
    ${filterParam(filters)}&
    ${searchParam(search)}&
    ${sortParam(sortKey, sortOrder)}&
    ${includeParam(includes)}
`;
